export default __webpack_public_path__ + "static/836-3bdb9f3c0d480d0847a7a968faa3d157.gif";